
import type { State } from '../types';
import type ProjectCollection from '../../models/ProjectCollection';
import type Project from '../../models/Project';

export function getProjects(state: State): ProjectCollection {
  return state.projects.projects;
}

export function isFetchingProjects(state: State): boolean {
  return state.projects.isFetchingProjects;
}

export function isCreatingProject(state: State): boolean {
  return state.projects.isCreatingProject;
}

export function getActiveProject(state: State): ?Project {
  return state.projects.activeProject;
}

export function projectNotificationsEnabled(state: State): boolean {
  return !!(state.projects.activeProject && state.projects.activeProject.notificationsEnabled);
}



// WEBPACK FOOTER //
// ./src/redux/projects/selectors.js